<template>
  <div
    class="absolute left-[var(--slider-fill)] top-1/2 z-20 h-[15px] w-[15px] hover:scale-150 -translate-x-1/2 -translate-y-1/2 rounded-full border border-[#cacaca] bg-white  ring-white/40 transition-opacity group-data-[active]:opacity-100 group-data-[dragging]:ring-4 will-change-[left]"
  />

  <!-- Add opacity-0 if we don't want the dragger always visible -->
</template>
